import axios from "axios";
import { APIs } from "../api/api";

const userData = JSON.parse(localStorage.getItem("_2mseamlessTailoring"));
let user = userData?.user;
let token = userData?.token;


const redirect_url = "https://2mseamless-tailoring.vercel.app/success";


const headers = {
  email: user?.email ?? "",
  authorization: token ?? "",
  redirect_url
};

export const makeLaundryOrder = (data) => {
  return axios
    .post(
      `${APIs.LAUNDRY.LAUNDRY_ORDER}`,
      {
       ...data
      },
      {
        headers: {
          authorization: token,
          email: user?.email,
        },
      }
    )
    .then((res) => res);
};

export const laundryCheckout = (id, img) => {
  return axios
    .post(`${APIs.LAUNDRY.LAUNDRY_CHECKOUT(id)}`, img, {
      headers,
    })
    .then((res) => res);
};

export const getLaundryTypes = () => {
  return axios.get(`${APIs.LAUNDRY.LAUNDRY_TYPES}`, {headers}).then((res) => res);
};
